import React from 'react';

const SectionBeforeChecklistComponent = ({checklists}) => {
  return checklists.map((checklist, index) => {
    return <p key={index}>{checklist}</p>;
  });
};

export default SectionBeforeChecklistComponent;
